import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive to Dallas needed",
      "Ideal for Barksdale AFB Global Strike Command families",
      "Perfect for B-52 aircrew with short-notice deployment orders",
      "Great for LSU Shreveport and Centenary study-abroad students",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Caddo Parish post offices",
      "Good for planned international trips from SHV",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection and restart the clock",
      "In-person clerk appointment required at Caddo Parish facilities",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: Dallas (~190 mi via I-20) or Houston (~240 mi via US-59/I-10)",
      "NPIC appointment required before driving to either location",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect a full-day commitment for the round trip",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function ShreveportProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      sectionId="processing-options"
      cityName="Shreveport"
      headingExtra="LA"
      introText="Shreveport-Bossier and Northwest Louisiana travelers — Barksdale Air Force Base Global Strike Command families deploying worldwide on short-notice orders, B-52 Stratofortress aircrew heading to forward operating bases in Europe and the Pacific, casino and gaming industry executives on international assignments, LSU Shreveport and Centenary College study-abroad students, and SHV international flyers — have several options for getting a passport fast. Here is how they compare, and why most Northwest Louisiana residents choose a U.S. Department of State registered passport courier rather than gambling on a 190-mile drive to Dallas."
      options={options}
      emergencyDescription="Barksdale AFB is home to Air Force Global Strike Command — the 2nd Bomb Wing and 307th Bomb Wing operate B-52 Stratofortresses that deploy worldwide on short-notice orders. A B-52 crew chief with a 72-hour deployment to RAF Fairford or Andersen AFB in Guam cannot wait for Dallas's single agency. The 190-mile I-20 corridor crosses through the heart of Dixie Alley — spring tornado season (March–May) sees supercell thunderstorms that spawn EF-3+ tornadoes crossing I-20 near Longview and Tyler with zero alternate routes through Piney Woods backroads. A Global Strike Command airman deploying to a NATO exercise in Europe cannot sit through a tornado warning on I-20 hoping one Dallas agency shared with 8M North Texans can squeeze in a last-minute appointment."
      disclaimerText="*Processing speed depends on eligibility and documentation. Shreveport does not have a regional passport agency — the closest is Dallas (~190 mi) via I-20 through tornado-prone east Texas. Not all applicants qualify for Regional Agency Processing."
    />
  );
}